// extracted by mini-css-extract-plugin
module.exports = {"content":"Empty_content__30aBH"};